import Dialog from "@mui/material/Dialog";
import { MdClose } from "react-icons/md";
import Button from "@mui/material/Button";
import Rating from "@mui/material/Rating";
import { useContext, useEffect, useState } from "react";

import { MyContext } from "../../App";
import ProductZoom from "../ProductZoom";
import { IoCartSharp } from "react-icons/io5";
import { postData, fetchDataFromApi } from "../../utils/api";
import "./price.css";

const ProductModal = (props) => {
  const [activePrice, setActivePrice] = useState(null);
  const [isAddedToMyList, setIsAddedToMyList] = useState(false);
  const [selectedPriceDetails, setSelectedPriceDetails] = useState(null);
  const context = useContext(MyContext);

  const handlePriceClick = (index) => {
    setActivePrice(index);
    setSelectedPriceDetails(props.data.prices[index]);
  };

  const addToCart = () => {
    if (selectedPriceDetails) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) {
        context.setAlertBox({
          open: true,
          error: true,
          msg: "Please login to add to cart.",
        });
      }
      const { _id } = selectedPriceDetails;
      const cartFields = {
        priceId: _id,
        productId: props?.data?._id || props?.data?.id,
        userId: user?._id || user?.userId,
        quantity: 1,
      };
      context.addToCart(cartFields);
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please select a price option.",
      });
    }
  };

  return (
    <Dialog
      open={context.isOpenProductModal}
      className="productModal"
      onClose={() => context.setIsOpenProductModal(false)}
    >
      <Button
        className="close_"
        onClick={() => context.setIsOpenProductModal(false)}
      >
        <MdClose />
      </Button>
      <h4 className="mb-1 font-weight-bold pr-5">{props?.data?.name}</h4>
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center mr-4">
          <span>Brands:</span>
          <span className="ml-2">
            <b>{props?.data?.brand || "N/A"}</b>
          </span>
        </div>
        <Rating
          name="read-only"
          value={parseInt(props?.data?.rating)}
          size="small"
          precision={0.5}
          readOnly
        />
      </div>
      <hr />

      <div className="row mt-2 productDetaileModal">
        <div className="col-md-5">
          <ProductZoom
            images={props?.data?.images}
            discount={props?.data?.discount}
          />
        </div>

        {/* <div className="col-md-7">
                    <div className="price-options">
                        <h5>Select a Price Option:</h5>
                        <div className="d-flex flex-wrap">
                            {props?.data?.prices.map((price, index) => (
                                <div
                                    key={index}
                                    className={`price-box ${activePrice === index ? "active" : ""}`}
                                    onClick={() => handlePriceClick(index)}
                                >
                                    <p className="text-black font-extrabold">Quantity: {price.quantity} {price.type}</p>
                                    <p className="text-black font-extrabold">Price: ₹ {price.actualPrice}</p>
                                    <p className="text-muted">Old Price: ₹ {price.oldPrice}</p>
                                    <p className="text-success font-bold">Discount: {price.discount}%</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <Button className="btn-blue bg-red btn-lg btn-round mt-4" onClick={addToCart}>
                        <IoCartSharp /> {context.addingInCart ? "Adding..." : " Add to cart"}
                    </Button>
                </div> */}

        <div className="col-md-7">
          <div className="price-options">
            <h5>Select a Price Option:</h5>
            <div className="d-flex flex-wrap">
              {props?.data?.prices.map((price, index) => (
                <div
                  key={index}
                  className={`price-box ${
                    activePrice === index ? "active" : ""
                  }`}
                  onClick={() => handlePriceClick(index)}
                >
                  <p className="text-black font-extrabold">
                    Quantity: {price.quantity} {price.type}
                  </p>
                  <p className="text-black font-extrabold">
                    Price: ₹ {price.actualPrice}
                  </p>
                  <p className="text-muted">Old Price: ₹ {price.oldPrice}</p>
                  <p className="text-success font-bold">
                    Discount: {price.discount}%
                  </p>
                </div>
              ))}
            </div>
          </div>

          <Button
            className={`btn-blue bg-red btn-lg btn-round mt-4 ${
              activePrice !== null &&
              props?.data?.prices[activePrice]?.countInStock < 1
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            onClick={addToCart}
            disabled={
              activePrice === null ||
              props?.data?.prices[activePrice]?.countInStock < 1
            }
          >
            {activePrice !== null &&
            props?.data?.prices[activePrice]?.countInStock < 1
              ? "Out of Stock"
              : context.addingInCart
              ? "Adding..."
              : "Add to Cart"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ProductModal;
